export async function apiRequest<T>(path: string, init: RequestInit = {}, csrfToken?: string | null): Promise<T> {
  const headers = new Headers(init.headers)
  headers.set('accept', 'application/json')
  if (init.body && !(init.body instanceof FormData)) headers.set('content-type', 'application/json')
  if (csrfToken) headers.set('x-csrf-token', csrfToken)
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' })
  const data = await response.json().catch(() => null) as T | { error?: { message?: string } } | null
  if (!response.ok) throw new Error((data as { error?: { message?: string } } | null)?.error?.message || 'The request could not be completed.')
  return data as T
}

export interface AccountHome {
  id: string
  name: string
  property_type: string
  year_built: number | null
  postal_region: string | null
  role: string
}

export interface AccountProjectSummary {
  id: string
  home_id: string
  title: string
  project_type: string
  status: string
  target_budget_minor: number | null
  updated_at: string
}
